(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.seq-area-faq-list details').forEach((item) => {
      if (item.dataset.seqAccordionReady === 'true') return;

      item.dataset.seqAccordionReady = 'true';

      item.addEventListener('toggle', () => {
        if (!item.open) return;

        const group = item.closest('.seq-area-faq-list');
        if (!group) return;

        group.querySelectorAll('details[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
